/**
 * Publishes the mobile filter bar's height as a custom property so anything
 * pinned to the bottom of the viewport can clear it — see the chat launcher
 * rule in the block's style.scss.
 *
 * The bar is not a fixed height: the toggle row is 64px on its own, but the
 * drawer slides open beneath it, so the height is measured rather than assumed.
 * A ResizeObserver keeps the value in step through the slide animation as well
 * as across breakpoint changes.
 */
const CUSTOM_PROPERTY = '--em--filter-bar--height';

const publishFilterBarHeight = (filterContainer) => {
	if (!filterContainer || typeof ResizeObserver === 'undefined') {
		return;
	}

	const publish = () => {
		const { height } = filterContainer.getBoundingClientRect();
		document.documentElement.style.setProperty(
			CUSTOM_PROPERTY,
			`${Math.round(height)}px`,
		);
	};

	new ResizeObserver(publish).observe(filterContainer);
	publish();
};

export default publishFilterBarHeight;
